function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 8.33341V8.83341C17.7761 8.83341 18 8.60956 18 8.33341H17.5ZM17.5 11.6667H18C18 11.3906 17.7761 11.1667 17.5 11.1667V11.6667ZM2.5 11.6667V11.1667C2.22386 11.1667 2 11.3906 2 11.6667H2.5ZM2.5 8.33341H2C2 8.60956 2.22386 8.83341 2.5 8.83341V8.33341ZM4.5 3.66675C3.11929 3.66675 2 4.78604 2 6.16675H3C3 5.33832 3.67157 4.66675 4.5 4.66675V3.66675ZM15.5 3.66675H4.5V4.66675H15.5V3.66675ZM18 6.16675C18 4.78604 16.8807 3.66675 15.5 3.66675V4.66675C16.3284 4.66675 17 5.33832 17 6.16675H18ZM18 8.33341V6.16675H17V8.33341H18ZM16.3333 10.0001C16.3333 9.35575 16.8557 8.83341 17.5 8.83341V7.83341C16.3034 7.83341 15.3333 8.80346 15.3333 10.0001H16.3333ZM17.5 11.1667C16.8557 11.1667 16.3333 10.6444 16.3333 10.0001H15.3333C15.3333 11.1967 16.3034 12.1667 17.5 12.1667V11.1667ZM18 13.8334V11.6667H17V13.8334H18ZM15.5 16.3334C16.8807 16.3334 18 15.2141 18 13.8334H17C17 14.6618 16.3284 15.3334 15.5 15.3334V16.3334ZM4.5 16.3334H15.5V15.3334H4.5V16.3334ZM2 13.8334C2 15.2141 3.11929 16.3334 4.5 16.3334V15.3334C3.67157 15.3334 3 14.6618 3 13.8334H2ZM2 11.6667V13.8334H3V11.6667H2ZM3.66667 10.0001C3.66667 10.6444 3.14433 11.1667 2.5 11.1667V12.1667C3.69662 12.1667 4.66667 11.1967 4.66667 10.0001H3.66667ZM2.5 8.83341C3.14433 8.83341 3.66667 9.35575 3.66667 10.0001H4.66667C4.66667 8.80346 3.69662 7.83341 2.5 7.83341V8.83341ZM2 6.16675V8.33341H3V6.16675H2Z",
  fill: "currentColor"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5 4.16675V5.83341",
  stroke: "currentColor",
  strokeLinecap: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5 9.16675V10.8334",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5 14.1667V15.8334",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.5476ac6b.svg";
export { ForwardRef as ReactComponent };